import React, { Component, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';
import '../../node_modules/font-awesome/scss/font-awesome.scss';
import Loader from './layout/Loader';
import Aux from '../hoc/_Aux';
import ScrollToTop from './layout/ScrollToTop';
import routes from '../route';
import { isAuthenticated, isOTPVerified, setOTPVerified } from './../services/auth';
import moment from 'moment';
import '@src/assets/css/styles.css';
import '@src/assets/css/custom.css';
import 'react-toastify/dist/ReactToastify.min.css';
import EnvironmentTag from '@components/EnvironmentTag';
import './I18n';
import { EstabelecimentoProvider } from '@src/contexts/estabelecimento';
import AvisoManutencao from '@components/Manutencao/AvisoManutencao';
import OTPVerification from '@components/OTPVerification/index';

const AdminLayout = Loadable({
  loader: () => import('./layout/AdminLayout'),
  loading: Loader
});

// Componente para rotas protegidas que requerem autenticação E verificação OTP
const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      // Verifica se está autenticado
      if (!isAuthenticated()) {
        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
      }

      // Verifica se o OTP foi verificado
      if (!isOTPVerified()) {
        return <Redirect to={{ pathname: '/mfa-validate', state: { from: props.location } }} />;
      }

      return <Component {...props} />;
    }}
  />
);

class App extends Component {
  componentDidMount() {
    moment.locale('pt-br');
  }

  handleOTPVerification = (isVerified) => {
    if (isVerified) {
      setOTPVerified(true);
      // Força re-render do componente
      this.forceUpdate();
    }
  };

  render() {
    const maintenanceMode = false;

    if (maintenanceMode) {
      return (
        <>
          <Route path="/aviso-manutencao" component={AvisoManutencao} />
          <Redirect to="/aviso-manutencao" />
        </>
      );
    }

    const menu = routes.map((route, index) => {
      return route.component ? (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          name={route.name}
          render={props => (
            <>
              <EnvironmentTag />
              <route.component {...props} />
            </>
          )}
        />
      ) : null;
    });

    return (
      <Aux>
        <EstabelecimentoProvider>
          <ScrollToTop>
            <Suspense fallback={<Loader />}>
              <Switch>
                {/* Rotas públicas primeiro */}
                {menu}

                {/* Rota para verificação OTP - só acessível se autenticado mas OTP não verificado */}
                <Route
                  path="/mfa-validate"
                  exact
                  name="MFA Validate"
                  render={(props) => {

                    // Se não está autenticado, redireciona para login
                    if (!isAuthenticated() && props.location.state?.nextStep !== 'mfa-validate') {
                      return <Redirect to="/login" />;
                    }

                    // Se já verificou OTP, redireciona para dashboard
                    if (isOTPVerified()) {
                      const redirectTo = props.location.state?.from?.pathname || '/dashboard';
                      return <Redirect to={redirectTo} />;
                    }

                    return (
                      <>
                        <EnvironmentTag />
                        <OTPVerification onVerify={this.handleOTPVerification} {...props} />
                      </>
                    );
                  }}
                />

                {/* Todas as rotas protegidas (dashboard, etc.) */}
                <ProtectedRoute path="/dashboard" component={AdminLayout} />
                <ProtectedRoute component={AdminLayout} />
              </Switch>
            </Suspense>
          </ScrollToTop>
        </EstabelecimentoProvider>
      </Aux>
    );
  }
}

export default App;
